import { fetch } from "../../../appContainer";
import {
  GET_INTERVENTIONS_LIST_IN_PROGRESS,
  GET_INTERVENTIONS_LIST_SUCCESS,
  GET_INTERVENTIONS_LIST_FAIL,
  GET_INTERVENTION_INFO_IN_PROGRESS,
  GET_INTERVENTION_INFO_SUCCESS,
  GET_INTERVENTION_INFO_FAIL,
  GET_INTERVENTIONS_LIST_FILTERS_IN_PROGRESS,
  GET_INTERVENTIONS_LIST_FILTERS_SUCCESS,
  GET_INTERVENTIONS_LIST_FILTERS_FAIL,
  GET_INTERVENTIONS_LIST_COUNT_IN_PROGRESS,
  GET_INTERVENTIONS_LIST_COUNT_SUCCESS,
  GET_INTERVENTIONS_LIST_COUNT_FAIL,
} from "../constants";

/**
 * Get interventions list
 */
export function getInterventionList(filters) {
  return (dispatch) => {
    dispatch({ type: GET_INTERVENTIONS_LIST_IN_PROGRESS });

    fetch("api").getInterventionList(
      filters,
      (list) => {
        dispatch({ type: GET_INTERVENTIONS_LIST_SUCCESS, payload: { list } });
      },
      () => dispatch({ type: GET_INTERVENTIONS_LIST_FAIL })
    );
  };
}

export function getInterventionListFilters(filters) {
  return (dispatch) => {
    dispatch({ type: GET_INTERVENTIONS_LIST_FILTERS_IN_PROGRESS });

    fetch("api").getInterventionListFilters(
      filters,
      (filters) => {
        dispatch({
          type: GET_INTERVENTIONS_LIST_FILTERS_SUCCESS,
          payload: { filters },
        });
      },
      () => dispatch({ type: GET_INTERVENTIONS_LIST_FILTERS_FAIL }),
    );
  };
}

export function getInterventionListCount(filters) {
  return (dispatch) => {
    dispatch({ type: GET_INTERVENTIONS_LIST_COUNT_IN_PROGRESS });

    fetch("api").getInterventionListCount(
      filters,
      (count) => {
        dispatch({
          type: GET_INTERVENTIONS_LIST_COUNT_SUCCESS,
          payload: { count },
        });
      },
      () => dispatch({ type: GET_INTERVENTIONS_LIST_COUNT_FAIL }),
    );
  };
}

/**
 * Get intervention info
 */
export function getInterventionInfo(uuid) {
  return (dispatch) => {
    dispatch({ type: GET_INTERVENTION_INFO_IN_PROGRESS });

    fetch("api").getInterventionInfo(
      uuid,
      (info) => {
        dispatch({ type: GET_INTERVENTION_INFO_SUCCESS, payload: { info } });
      },
      () => dispatch({ type: GET_INTERVENTION_INFO_FAIL })
    );
  };
}
